<template>
  <NcrmRecordEditDialog
    :model-value="modelValue"
    :title="isEdit ? $t('users.dialog.editTitle') : $t('users.dialog.addTitle')"
    header-icon="mdi-account-cog-outline"
    :max-width="560"
    :save-disabled="!form.email"
    @update:model-value="$emit('update:modelValue', $event)"
    @save="$emit('save', { ...form })"
  >
    <v-alert v-if="error" type="error" density="compact" class="mb-4">
      {{ error }}
    </v-alert>

    <v-row dense>
      <v-col cols="12" md="6">
        <v-text-field
          :label="$t('users.fields.email')"
          v-model="form.email"
          type="email"
          required
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          :label="$t('users.fields.password')"
          v-model="form.password"
          type="password"
          :hint="isEdit ? $t('users.fields.passwordHintEdit') : ''"
          persistent-hint
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field :label="$t('users.fields.name')" v-model="form.name" />
      </v-col>
      <v-col cols="12" md="6">
        <v-select
          :label="$t('users.fields.role')"
          :items="roleOptions"
          item-title="label"
          item-value="value"
          v-model="form.role"
          clearable
          :hint="$t('users.fields.roleHint')"
          persistent-hint
        />
      </v-col>
      <v-col v-if="showCompany" cols="12" md="6">
        <v-select
          :label="$t('users.fields.companyShort')"
          :items="companyOptions"
          item-title="label"
          item-value="id"
          v-model="form.company_id"
          clearable
          :hint="$t('users.fields.companyHint')"
          persistent-hint
        />
      </v-col>
    </v-row>
  </NcrmRecordEditDialog>
</template>

<script>
import { defineComponent } from "vue";
import NcrmRecordEditDialog from "@/components/ncrm/shared/NcrmRecordEditDialog.vue";

// Add/edit user drawer extracted from users.vue. Keeps a local working copy so
// cancelling never mutates the parent record; emits the final form via `save`.
// The parent remains responsible for building the API payload (company scoping).
export default defineComponent({
  name: "UserFormDrawer",
  components: { NcrmRecordEditDialog },
  props: {
    modelValue: { type: Boolean, default: false },
    isEdit: { type: Boolean, default: false },
    user: { type: Object, default: () => ({}) },
    roleOptions: { type: Array, default: () => [] },
    companyOptions: { type: Array, default: () => [] },
    showCompany: { type: Boolean, default: false },
    error: { type: String, default: "" },
  },
  emits: ["update:modelValue", "save"],
  data() {
    return {
      form: { ...this.user },
    };
  },
  watch: {
    modelValue(open) {
      if (open) this.form = { ...this.user };
    },
    user(next) {
      if (this.modelValue) this.form = { ...next };
    },
  },
});
</script>
